import { Toaster as Sonner } from "sonner";
import { toast } from "sonner";
import "./basetoast.css";
import "./customtoast.css";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      {...props}
      className="toaster"
      expand={true}
      richColors={false}
      closeButton={false}
      toastOptions={{
        duration: 4000,
        classNames: {
          toast: "toast",
          title: "toast-title",
          description: "toast-description",
          actionButton: "toast-action-button",
          cancelButton: "toast-cancel-button",
          closeButton: "toast-close-button",
        },
      }}
    />
  );
};

/**
 * Helper function to copy text to clipboard
 * Uses modern clipboard API with fallback for older browsers
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for older browsers
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      return true;
    } catch (fallbackErr) {
      console.error("Failed to copy to clipboard:", fallbackErr);
      return false;
    }
  }
};

/**
 * Creates an action button configuration for error toasts that copies the error message
 * @param errorMessage - The error message to copy
 * @returns Action button configuration for sonner toast
 */
export const createErrorCopyAction = (errorMessage: string) => ({
  label: "Copy",
  onClick: async () => {
    const success = await copyToClipboard(errorMessage);
    if (success) {
      toast.success("Error message copied to clipboard");
    } else {
      toast.error("Failed to copy error message");
    }
  },
});

export { Toaster };
